import { UI } from '@/Components/UI';
import { useDynamicInputs } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const InstructionsForm = () => {
    const { t } = useTranslation(['recipes']);
    const { addValue, removeValue, values } = useDynamicInputs('instructions', { description: '', image: undefined });

    useEffect(() => {
        if (!values || values.length === 0) {
            addValue();
        }
    }, [values]);

    return (
        <>
            <UI.Heading level={2}>
                {t('form.instructions.heading')}
            </UI.Heading>

            <div className={'flex flex-col gap-2 mb-2'}>
                {values?.map((_, index) => (
                    <div
                        key={index}
                        className={'px-4 py-2 rounded-lg border border-primary'}>
                        <div className={'col-span-2 text-end'}>
                            <UI.Button
                                buttonStyle={'tonal'}
                                type={'button'}
                                onClick={() => removeValue(index)}>
                                <UI.Icon name={'delete'} />
                            </UI.Button>
                        </div>

                        <UI.Form.Textarea
                            name={`instructions.${index}.description`}
                            label={t('form.instructions.instruction')} />

                        <UI.Form.ImageInput
                            name={`instructions.${index}.image`}
                            label={t('form.instructions.image')} />
                    </div>
                ))}

                <UI.Button
                    buttonStyle={'tonal'}
                    type={'button'}
                    onClick={addValue}>
                    <UI.Icon name={'add'} />
                </UI.Button>
            </div>
        </>
    );
};
